"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _tokens = _interopRequireDefault(require("../tokens"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MuiTooltip = function MuiTooltip(theme) {
  return {
    tooltip: {
      borderRadius: _tokens["default"].radii.semiRounded,
      backgroundColor: theme.palette.grey[700]
    },
    arrow: {
      color: theme.palette.grey[700]
    }
  };
};

var _default = MuiTooltip;
exports["default"] = _default;